import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { addApplicant } from 'products/nomad_insurance/state/application';
import AnimatedAccordion from 'products/nomad_insurance/components/AnimatedAccordion';
import { ReactComponent as UserPlusIcon } from 'products/nomad_insurance/assets/img/icons/user-plus.svg';
import { PLANS } from 'products/nomad_insurance/constants';
import ApplicantForm from '../ApplicantForm';
import { Wrapper, AddWrapper, IconContainer } from './styled';
import ChevronButton from '../ChevronButton';

const AddApplicant = ({ onAddCallback }) => {
  const dispatch = useDispatch();
  const { addons } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const hasUSCoverage = Boolean(
    addons.find((addon) => addon.value === PLANS.USA_COVERAGE.value)
  );
  const { offer, planholder } = useSelector((state) => state.nomadInsurance.application);
  const { data: userProfile } = useSelector((state) => state.app.profile);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleAddGroupMember = (info) => {
    dispatch(addApplicant(offer.applicationBundleId, info));
    onAddCallback();
    setIsFormOpen(false);
  };

  const handleCancel = () => {
    setIsFormOpen(false);
  };

  return (
    <Wrapper>
      <ChevronButton
        onClick={() => setIsFormOpen(!isFormOpen)}
        isOpen={isFormOpen}
        color="confetti+4"
      >
        <AddWrapper>
          <IconContainer>
            <UserPlusIcon />
          </IconContainer>
          Add another member
        </AddWrapper>
      </ChevronButton>

      <AnimatedAccordion isOpen={isFormOpen}>
        <ApplicantForm
          onSubmit={handleAddGroupMember}
          onCancel={handleCancel}
          hasUSCoverage={hasUSCoverage}
          planholder={planholder}
          homeCountry={userProfile?.homeCountry}
        />
      </AnimatedAccordion>
    </Wrapper>
  );
};

AddApplicant.propTypes = {
  onAddCallback: PropTypes.func
};

export default AddApplicant;
